// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../procollege/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../procollege/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-htmlContent p{margin:0}`, "",{"version":3,"sources":["webpack://./../blocks/psm_desktop2/components/announceArchive.vue"],"names":[],"mappings":"AACA,iBACE,QAAA","sourcesContent":["\r\n.v-htmlContent p{\r\n  margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
